export default __webpack_public_path__ + "svg/ceo/leadership.svg?2cbcfe19";